import { useEffect, useState } from 'react';
import { getDemoVideos } from '../../Store/reducers/DemoVideos';
import { useReduxDispatch, useReduxSelector } from '../../Store/reduxHooks';
import PALoader from '../../SharedComponets/PALoader';
import { TrainingVideoIcon } from '../../Universal/Assets';
import ViewModal from './ViewModal';
import { STRINGS } from '../../Constants/ConstantStrings';
import { modalStyles } from '../../Universal/NovusDSImports/variants';
import { RootState } from '../../store';

interface demoVideosProps {
  isDemoVideoModalOpen: boolean;
  setIsDemoVideoModalOpen: (open: boolean) => void;
}

const DemoVideos: React.FC<demoVideosProps> = (props) => {
  const { isDemoVideoModalOpen, setIsDemoVideoModalOpen } = props;
  const dispatch = useReduxDispatch();
  interface VideoType {
    id: number;
    title: string;
    video: string;
    description?: string;
  }

  const [selectedVideo, setSelectedVideo] = useState<VideoType | null>(null);
  const isFetchingDemovideos = useReduxSelector(
      (state) => state.DemoVideos.isFetchingDemoVideos
    ),
    demoVideosData = useReduxSelector((state) => state.DemoVideos.demoVideos);

  const isMobileScreen = useReduxSelector(
    (state: RootState) => state.Common.isMobileScreen
  );

  const fetchDemoVideos = () => {
    dispatch(
      getDemoVideos({ params: { fields: 'id,title,description,duration' } })
    );
  };

  const getDuration = (seconds: number): string => {
    const minutes =
      Math.floor(seconds / 60) > 9
        ? Math.floor(seconds / 60)
        : `0${Math.floor(seconds / 60)}`;
    const secs = seconds % 60 > 9 ? seconds % 60 : `0${seconds % 60}`;
    return `${minutes}:${secs}`;
  };

  const handleVideoClick = (item) => {
    setSelectedVideo(item);
  };

  useEffect(() => {
    fetchDemoVideos();
  }, []);

  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.50)'
    },
    content: {
      maxWidth: isMobileScreen ? '95%' : '60%',
      height: '70%',
      minWidth: isMobileScreen ? '95%' : '60%'
    }
  };

  const renderVideoDetails = (item: any) => {
    return (
      <>
        <div
          tabIndex={0}
          className="version-details video-details"
          onClick={() => {
            setIsDemoVideoModalOpen(true);
            handleVideoClick(item);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setIsDemoVideoModalOpen(true);
              handleVideoClick(item);
            }
          }}
        >
          <div className="version" data-testid="video-title">
            <span className="version-label">{item.title}</span>
            <br />
          </div>
          <div className="version-release-description p-0">
            {item.description}
          </div>
          <div className="d-flex align-items-center gap-2">
            <div className="read-more video-icon">
              <img
                src={TrainingVideoIcon}
                alt="Play"
                className="training-video-icon"
              />
            </div>
            <span className="video-duration">
              {getDuration(item?.duration)}
            </span>
          </div>
        </div>
      </>
    );
  };

  if (isFetchingDemovideos) return <PALoader />;

  return isFetchingDemovideos ? (
    <PALoader />
  ) : demoVideosData?.results?.length ? (
    <>
      {demoVideosData?.results?.length ? (
        <>{demoVideosData.results.map((vid) => renderVideoDetails(vid))}</>
      ) : (
        <div className="no-release-notes">{STRINGS.NO_DEM0_VIDEOS}</div>
      )}

      {isDemoVideoModalOpen && (
        <ViewModal
          isOpen={isDemoVideoModalOpen}
          isBodyPaddingNone={true}
          showFooter={false}
          showHeader={true}
          title={selectedVideo?.title || STRINGS.DEMO_VIDEO}
          customFooter={null}
          closeModal={() => setIsDemoVideoModalOpen(false)}
          selectedDemoVideo={selectedVideo}
          setSelectedVideo={setSelectedVideo}
          activeTab="DEMO_VIDEOS"
          {...modalStyles}
          style={customStyles}
        />
      )}
    </>
  ) : (
    <div className="no-release-notes">{STRINGS.NO_DEM0_VIDEOS}</div>
  );
};

export default DemoVideos;
